import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberCommunicationSettings defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberCommunicationSettingsService } from 'services/memberCommunicationSettings';
 *
 * // create service instance and send/cancel request
 * const memberCommunicationSettingsService = new MemberCommunicationSettingsService();
 * const result = await memberCommunicationSettingsService.fetchData( '<user-id>' ); // fetch data
 * memberCommunicationSettingsService.cancel(); // cancel an active request
 */
export class MemberCommunicationSettingsService extends HttpService {

    // make given contact as default one
    async fetchAddEditForm( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            const fields = get( response, 'body.component.structure.fields', {} );
            const actions = get( response, 'body.component.structure.actions', [] );
            const values = get( response, 'body.component.data', [] );
            const addTitle = get( response, 'body.component.structure.title', [] );
            const editTitle = get( response, 'body.component.structure.editTitle', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    fields,
                    actions,
                    values,
                    addTitle,
                    editTitle
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
